import produce from 'immer';

const INITIAL_STATE = {
  token: null,
  profile: {},
  signed: false,
  loading: false,
};

export default function auth(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@auth/SIGN_IN_REQUEST':
    case '@auth/SIGN_UP_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
      });

    case '@auth/SIGN_IN_SUCCESS':
      return produce(state, draft => {
        draft.token = action.payload.token;
        draft.profile = action.payload.user;
        draft.signed = true;
        draft.loading = false;
      });

    case '@auth/SIGN_FAILURE':
    case '@auth/SIGN_UP_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.signed = false;
        draft.profile = {};
        draft.token = null;
      });

    default:
      return state;
  }
}
